
const sidebarDefault = {
	visible: false,
	view: '',
	fixed: false,
	styles: {
	},
	outputData: [],
	context: {
		actionName: '',
		value: '',
	},
	initialContext: null,
	resetButton: null,
	title: '',
	titleInfo: '',
	info: null,
	applied: false,
	closeOnSave: true,
	revert: false,
	doTrack: false,
};


export default {
	state: Object.assign({}, sidebarDefault),

	mutations: {
		updateSidebar(state, sidebarData) {
			const keys = Object.keys(sidebarData);
			keys.forEach((key) => {
				if (key === 'context') {
					state.applied = false;
				}

				state[key] = sidebarData[key];

				/* Applied-Status zurücksetzen, wenn Änderungen vorgenommen wurden */
				if (key === 'visible' && sidebarData[key]) {
					sidebarData.context = sidebarData.context ? sidebarData.context : {};
					state.initialContext = JSON.parse(JSON.stringify(sidebarData.context));
				}

				/* Context resetten, wenn Änderungen übernommen wurden */
				if (state.applied) {
					state.context = JSON.parse(JSON.stringify(state.initialContext));
				}
			});
		},

		resetSidebar(state) {
			const keys = Object.keys(sidebarDefault);
			keys.forEach((key) => {
				state[key] = sidebarDefault[key];
			});
		},

		resetSidebarContext(state) {
			state.context = Object.assign({}, sidebarDefault.context);
		},
	},

	actions: {
		updateSidebar({ commit, state }, sidebarData) {
			if (sidebarData.doTrack) {
				sidebarData.doTrack = false;
				commit('pushToSidebarHistory', state);
			}
			commit('updateSidebar', sidebarData);
		},

		revertSidebar({ commit, getters }) {
			commit('updateSidebar', getters.peekFromSidebarHistory);
			commit('popFromSidebarHistory');
		},

		resetSidebar({ commit }, initialData) {
			commit('resetSidebar', initialData);
		},

		resetSidebarContext({ commit }) {
			commit('resetSidebarContext');
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js